import { render } from "./BaseCardHeader.vue?vue&type=template&id=21ae34f8"
import script from "./BaseCardHeader.vue?vue&type=script&lang=js"
export * from "./BaseCardHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__